export const FETCH_ACCOUNT_NAMES = "FETCH_ACCOUNT_NAMES";
export const FETCH_ACCOUNT_NAMES_SUCCESS = "FETCH_ACCOUNT_NAMES_SUCCESS";
export const FETCH_ACCOUNT_NAMES_FAILURE = "FETCH_ACCOUNT_NAMES_FAILURE";

export const FETCH_ACCOUNT_NAMES_ALL = "FETCH_ACCOUNT_NAMES_ALL";
export const FETCH_ACCOUNT_NAMES_ALL_SUCCESS =
  "FETCH_ACCOUNT_NAMES_ALL_SUCCESS";
export const FETCH_ACCOUNT_NAMES_ALL_FAILURE =
  "FETCH_ACCOUNT_NAMES_ALL_FAILURE";

export const FETCH_ACCOUNT_BY_ID = "FETCH_ACCOUNT_BY_ID";
export const FETCH_ACCOUNT_BY_ID_RESET = "FETCH_ACCOUNT_BY_ID_RESET";
export const FETCH_ACCOUNT_BY_ID_SUCCESS = "FETCH_ACCOUNT_BY_ID_SUCCESS";
export const FETCH_ACCOUNT_BY_ID_FAILURE = "FETCH_ACCOUNT_BY_ID_FAILURE";
